<!-- E-poe kategooriate lisamise/muutmise vaheleht -->
<template>
  <page-header class="px-10">
    <h1>Lisa/muuda kategoooriat</h1>
  </page-header>
  <v-sheet class="post-body d-flex justify-center pa-10 ga-10">
    <div class="products">
      <h2 class="d-flex justify-center">Uus kategooria</h2>
      <v-form ref="form">
        <v-text-field
            v-model="category.name"
            label="Kategooria"
            variant="outlined"
          hint="Kasuta kuju: Kategooria - Alamkategooria - Alamalamkategooria"
          persistent-hint
            :rules="rules"
        ></v-text-field>
        <v-text-field
            v-model="category.name_en"
            label="Kategooria(en)"
            variant="outlined"
        ></v-text-field>
        <v-text-field
            v-model="category.name_ru"
            label="Kategooria(ru)"
            variant="outlined"
        ></v-text-field>
      </v-form>
      <v-btn color="success" @click="addCategory"  class="mt-2">Lisa</v-btn>
    </div>
    <div class="products">
      <h2 class="d-flex justify-center">Muuda kategooriat</h2>
      <v-list v-if="!edit" v-for="category in categories">
        <v-list-item active="" active-color="eraklient">
          <div class="d-flex justify-space-between align-center">
            {{category.name}}
            <span @click="changeCat(category)" class="clickable">
              <i class="fa fa-pen-to-square pa-2"></i>
            </span>
          </div>
        </v-list-item>
      </v-list>
      <v-form v-if="edit" ref="form">
        <v-text-field
            v-model="cat.name"
            label="Kategooria"
            variant="outlined"
          hint="Kasuta kuju: Kategooria - Alamkategooria - Alamalamkategooria"
          persistent-hint
            :rules="rules"
        ></v-text-field>
        <v-text-field
            v-model="cat.name_en"
            label="Kategooria(en)"
            variant="outlined"
        ></v-text-field>
        <v-text-field
            v-model="cat.name_ru"
            label="Kategooria(ru)"
            variant="outlined"
        ></v-text-field>
        <v-btn block color="eraklient" @click="this.edit = false">Tagasi</v-btn>
        <v-btn block color="success" @click="updateCategory(cat.id)" class="mt-2">Uuenda</v-btn>
        <alert>
          <template #first-btn>Kustuta</template>
          <div class="text-h5 justify-center text-center">Kas oled kindel, et soovid kategooria kustutada?</div>
          <template #confirmation-btn>
            <v-btn class="text-none mr-4 font-weight-bold" color="eraklient" min-width="92" rounded @click.prevent="deleteCategory(cat.id)">Jah</v-btn>
          </template>
        </alert>
      </v-form>

      <v-dialog v-model="deleteErrorDialog" width="auto" transition="none">
        <v-card class="delete-error-card" min-width="360">
          <v-toolbar color="error" title="Viga" class="text-white">
            <v-btn icon="mdi-close" color="white" @click="deleteErrorDialog = false"></v-btn>
          </v-toolbar>
          <v-card-text class="text-h6 justify-center text-center delete-error-text">
            {{ deleteErrorMessage }}
          </v-card-text>
          <v-divider color="error"></v-divider>
          <div class="ma-4 d-flex justify-end">
            <v-btn class="text-none font-weight-bold" min-width="92" rounded color="error" variant="elevated" @click="deleteErrorDialog = false">OK</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </v-sheet>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import Alert from "@/components/Alert";
export default {
  name: "AddCategory",
  components: {Alert, PageHeader},
  data() {
    return {
      valid: false,
      edit: false,
      deleteErrorDialog: false,
      deleteErrorMessage: "",
      categories: this.$store.state.categories,
      cat: [],
      category: {
        name: null,
        name_en: null,
        name_ru: null
      },
      rules: [
        value => {
          if (value) return true
          return 'Ei saa olla tühi.'
        },
        value => {
          const parts = String(value || '')
              .split('-')
              .map((part) => part.trim())
              .filter(Boolean);

          if (parts.length <= 3) return true;
          return 'Maksimaalselt 3 taset: Kategooria - Alamkategooria - Alamalamkategooria';
        },
      ],
    };
  },
  methods: {
    normalizeCategoryPath(value) {
      return String(value || '')
          .split('-')
          .map((part) => part.trim())
          .filter(Boolean)
          .join(' - ');
    },
    async fetchACategory(id) {
      fetch(`${process.env.VUE_APP_SERVER_URL}/api/categories/${id}`)
          .then((response) => response.json())
          .then((data) => (this.cat = data))
          .catch((err) => console.log(err.message));
    },
    async addCategory() {
      const {valid} = await this.$refs.form.validate()

      if (valid) {
        const data = {
          name: this.normalizeCategoryPath(this.category.name),
          name_en: this.category.name_en ? this.normalizeCategoryPath(this.category.name_en) : null,
          name_ru: this.category.name_ru ? this.normalizeCategoryPath(this.category.name_ru) : null,
        };
        fetch(`${process.env.VUE_APP_SERVER_URL}/api/categories`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
            .then((response) => {
              console.log(response.data);
              location.assign("/tooted");
            })
            .catch((e) => {
              console.log(e);
              console.log("error");
            });
      }
    },
    async updateCategory(id) {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        const payload = {
          ...this.cat,
          name: this.normalizeCategoryPath(this.cat.name),
          name_en: this.cat.name_en ? this.normalizeCategoryPath(this.cat.name_en) : null,
          name_ru: this.cat.name_ru ? this.normalizeCategoryPath(this.cat.name_ru) : null,
        };

        fetch(`${process.env.VUE_APP_SERVER_URL}/api/categories/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        })
            .then((response) => {
              console.log(response.data);
              location.assign("/tooted");
            })
            .catch((e) => {
              console.log(e);
            });
      }
    },
    deleteCategory(id) {
      this.deleteErrorDialog = false;
      this.deleteErrorMessage = "";

      fetch(`${process.env.VUE_APP_SERVER_URL}/api/categories/${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      })
          .then(async (response) => {
            if (!response.ok) {
              let message = "This category is in use and can't be deleted";

              try {
                const payload = await response.json();
                if (payload && payload.error) {
                  message = payload.error;
                }
              } catch (err) {
                console.log(err);
              }

              throw new Error(message);
            }

            location.assign("/tooted");
          })
          .catch((e) => {
            this.deleteErrorMessage = e.message || "See kategooria on kasutuses ja seda ei saa kustutada.";
            this.deleteErrorDialog = true;
          });
    },
    changeCat(category) {
      this.fetchACategory(category.id);
      this.edit = true;
    }
  }
}
</script>

<style scoped>
.delete-error-card {
  border: 2px solid rgb(var(--v-theme-error));
  box-shadow: 0 12px 28px rgba(183, 28, 28, 0.35);
}

.delete-error-text {
  color: rgb(var(--v-theme-error));
  background-color: rgba(244, 67, 54, 0.08);
  padding-top: 20px;
  padding-bottom: 20px;
}

</style>
